var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabStoryblocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.04 24.143c6.65 0 12.041-5.405 12.041-12.072C24.081 5.405 18.691 0 12.041 0 5.39 0 0 5.405 0 12.071c0 6.667 5.39 12.072 12.04 12.072z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.498 5.745v8.13a4.05 4.05 0 01-2.867-1.19 4.07 4.07 0 010-5.75 4.05 4.05 0 012.867-1.19zM12.582 18.396v-8.13a4.05 4.05 0 012.867 1.19 4.07 4.07 0 010 5.75 4.05 4.05 0 01-2.867 1.19zM14.493 9.577a1.914 1.914 0 001.911-1.916 1.914 1.914 0 00-1.91-1.916 1.914 1.914 0 00-1.912 1.916c0 1.058.856 1.916 1.911 1.916zM9.587 18.397a1.914 1.914 0 001.911-1.916 1.914 1.914 0 00-1.911-1.917 1.914 1.914 0 00-1.911 1.916c0 1.059.855 1.917 1.911 1.917z",
    fill: "#fff"
  })));
}
export default SvgTabStoryblocks;